// extracted by mini-css-extract-plugin
module.exports = {"login":"LoginForm_login__uCUtL","login__forget-pass":"LoginForm_login__forget-pass__2kjRY","login__register-btn":"LoginForm_login__register-btn__JB-65"};